<template>
<IdeologicalCourses  :courses="courses" :viewCourse="viewCourse" :flag="flag" class="ideologicalCoursesContent"/>
</template>

<script>
import { ideologicalCourses } from "@/api/mock.js";
import IdeologicalCourses from "@/components/ideologicalCourses/ideologicalCourses.vue"
export default {
  name: "ideologicalCourses",
  data() {
    return {
      courses: [],
      flag:false
    };
  },
  created() {
    ideologicalCourses()
      .then(res => {
        // 返回数据
        this.courses = res.list;
      })
      .catch(err => {
        // 异常情况
        console.log(err);
      });
  },
  methods: {
    viewCourse(item) {
      window.open(
        `https://www.ulearning.cn/ulearning_web/web!courseDetail.do?courseID=${item.id}`
      );
    }
  },
   components:{
    IdeologicalCourses
  }
};
</script>
<style lang="scss" scoped>
.ideologicalCoursesContent{
  padding-top: 55px;
  padding-bottom: 50px;
}
</style>